import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import * as CryptoJS from 'crypto-js';

@Injectable({ providedIn: 'root' })
export class StorageService {
   private secretKey = environment.secretkey;

  constructor() {}

  setItem(key: string, value: any): void {
    const stringValue = JSON.stringify(value);
    const encrypted = CryptoJS.AES.encrypt(stringValue, this.secretKey).toString();
    sessionStorage.setItem(key, encrypted);
  }

  getItem(key: string): any {
    const encrypted = sessionStorage.getItem(key);
    if (!encrypted) {
      return null;
    }

    try {
      const bytes = CryptoJS.AES.decrypt(encrypted, this.secretKey);
      const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
      return JSON.parse(decryptedData);
    } catch (e) {
      console.error('Decryption error', e);
      return null;
    }
  }

  removeItem(key: string): void {
    sessionStorage.removeItem(key);
  }

  clear(): void {
    sessionStorage.clear();
  }
}
